export default __webpack_public_path__ + "static/media/chaqueta-bombero-hombre.12023a5e.png";